import { createFileRoute } from "@tanstack/react-router";
import CarmaxUnit from "@/components/carmax/CarmaxUnit";

// Test-only build of the new unit page. Live /rv-search/$slug is untouched.
export const Route = createFileRoute("/preview/rv/$slug")({
  head: () => ({
    meta: [
      { title: "New Unit Page Preview | Rex & Sons RVs" },
      { name: "description", content: "Test layout of the new Rex & Sons RVs unit page." },
      { property: "og:title", content: "New Unit Page Preview | Rex & Sons RVs" },
      { property: "og:description", content: "Test layout of the new Rex & Sons RVs unit page." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: CarmaxUnit,
});
